enum Features {
  HcpcsCodes = 'hcpcsCodes',
  PageClassification = 'pageClassification',
  DatasetHPL_CA = 'dataset.healthcare_practitioner_licensure.ca',
  DatasetHPL_FL = 'dataset.healthcare_practitioner_licensure.fl',
  DatasetHPL_WA = 'dataset.healthcare_practitioner_licensure.wa',
  PatientPortal = 'patientPortal',
  DocumentReprocessing = 'documentReprocessing',
  Invoicing = 'invoicing',
  BillingHideOverdueWarnings = 'billing.hideOverdueWarnings',
  AIChat = 'aiChat',
  AIChatHidePlatformPrompts = 'aiChat.hidePlatformPrompts',
  EpisodesAuthorSuggestion = 'episodes.authorSuggestion'
}

export default Features;

export type DatasetHPLFeatures = Features.DatasetHPL_CA | Features.DatasetHPL_FL | Features.DatasetHPL_WA;
